import React, { useState, useRef, useEffect } from 'react';
import { TextField, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';

export default function EditableHeader({ value, onSave, onCancel, style, isEditing, onStartEdit }) {
    const [editValue, setEditValue] = useState(value || '');
    const [isHovered, setIsHovered] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isEditing]);

    useEffect(() => {
        console.log('[EditableHeader] Value prop changed to:', value);
        setEditValue(value || '');
    }, [value]);

    const handleSave = () => {
        onSave(editValue);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            onCancel();
        }
    };

    if (!isEditing) {
        return (
            <div
                style={{
                    ...style,
                    cursor: 'pointer',
                    minHeight: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    width: '100%',
                }}
                onDoubleClick={onStartEdit}
                onClick={onStartEdit}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                title="Click to edit"
            >
                <span style={{ flex: 1, textAlign: 'center' }}>
                    {value || <span style={{ color: '#999', fontStyle: 'italic' }}>Empty</span>}
                </span>
                <EditIcon
                    sx={{
                        fontSize: '14px',
                        opacity: isHovered ? 0.5 : 0,
                        color: 'text.secondary',
                        transition: 'opacity 0.2s',
                        position: 'absolute',
                        right: '4px',
                    }}
                />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '2px' }}>
            <TextField
                inputRef={inputRef}
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onKeyDown={handleKeyDown}
                size="small"
                variant="standard"
                sx={{
                    '& .MuiInputBase-input': {
                        fontSize: 'inherit',
                        textAlign: 'center',
                        padding: '2px 4px',
                    }
                }}
            />
            <IconButton size="small" onClick={handleSave} color="primary">
                <CheckIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={onCancel}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    );
}
